import debounce from '../util/debounce';
import initTransparentHeader from '../globals/init-transparent-header';
import setMainSpacing from '../globals/set-main-spacing';
import {setVarsOnResize} from '../globals/height';
import preventOverflow from '../globals/prevent-overflow';
import resizeListener from '../globals/resize';
import scrollListener from '../globals/scroll';
import wrapElements from '../globals/wrap';
import isTouch from '../util/touch';
import {loading} from '../globals/loading';

resizeListener();
scrollListener();
isTouch();

const headerFunctions = debounce(() => {
  // Recheck sticky header settings if section is set to hidden
  initTransparentHeader();
  setMainSpacing();
}, 300);

window.addEventListener('load', () => {
  setVarsOnResize();
  preventOverflow(document);
  wrapElements(document);
  loading();
});

document.addEventListener('shopify:section:load', (e) => {
  const container = e.target;

  window.dispatchEvent(new Event('resize'), {bubbles: true});

  preventOverflow(container);
  wrapElements(container);
  setVarsOnResize();

  headerFunctions();
});

document.addEventListener('shopify:section:reorder', () => {
  headerFunctions();
});

document.addEventListener('shopify:section:unload', () => {
  headerFunctions();
});

document.addEventListener('theme:resize:width', setMainSpacing);
